import { Fragment, useState } from "react";
import { ChevronDown, ChevronRight, Trash2 } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { dec, eur, pill } from "@/components/excelVoce/format";
import { PREZZO_LABEL } from "./labels";

const Quote = ({ quote }) => (
  <ul className="text-[11px] text-slate-500 space-y-0.5 pl-6">{quote.map((q, i) => (
    <li key={i}>{q.data} · {q.esecutore} · {dec(q.quantita)} · verificata da {q.verificata_da || "—"}{q.bloccante ? " · contabilizzata" : ""}</li>))}
  </ul>
);

const Azioni = ({ r, act }) => (
  <div className="flex flex-wrap gap-1 justify-end">
    {r.tipo_riga === "RETTIFICA" ? act.rettifica && <Button size="sm" variant="ghost" onClick={() => act.rettifica(r)} data-testid={`riga-elimina-${r.id}`}><Trash2 className="h-3.5 w-3.5" /></Button> : <>
      {act.prezzo && ["DA_RISOLVERE", "MANUALE"].includes(r.prezzo_origine) && !r.esclusa && <Button size="sm" variant="outline" onClick={() => act.prezzo(r)} data-testid={`riga-prezzo-${r.id}`}>Prezzo</Button>}
      {act.escludi && (r.esclusa
        ? <Button size="sm" variant="outline" onClick={() => act.includi(r)} data-testid={`riga-includi-${r.id}`}>Includi</Button>
        : <Button size="sm" variant="outline" onClick={() => act.escludi(r)} data-testid={`riga-escludi-${r.id}`}>Escludi</Button>)}
    </>}
  </div>
);

const Riga = ({ r, act }) => {
  const [open, setOpen] = useState(false);
  const daRisolvere = r.prezzo_origine === "DA_RISOLVERE" && !r.esclusa;
  return (
    <Fragment>
      <TableRow className={`${r.esclusa ? "opacity-50" : ""} ${daRisolvere ? "bg-amber-50" : ""}`} data-testid={`sal-voce-${r.id}`}>
        <TableCell className="text-xs whitespace-nowrap">
          {r.quote.length > 0 && <button type="button" onClick={() => setOpen(!open)} data-testid={`riga-quote-${r.id}`}>{open ? <ChevronDown className="h-3 w-3 inline" /> : <ChevronRight className="h-3 w-3 inline" />}</button>} {r.num_ord}
        </TableCell>
        <TableCell className="text-xs max-w-sm">
          <div className="line-clamp-2">{r.tariffa ? `${r.tariffa} · ` : ""}{r.designazione}</div>
          <div className="mt-0.5 flex flex-wrap gap-1">
            <span className={`${pill} ${daRisolvere ? "bg-amber-100 text-amber-800 border-amber-300" : "text-slate-500"}`} title={r.prezzo_nota || ""}>{PREZZO_LABEL[r.prezzo_origine]}</span>
            {r.esclusa && <span className={`${pill} text-rose-700 border-rose-200`}>Esclusa · {r.motivo}</span>}
            {!r.esclusa && r.motivo && <span className="text-[11px] text-slate-500">{r.motivo} ({r.risolta_da})</span>}
          </div>
        </TableCell>
        <TableCell className="text-xs">{r.um}</TableCell>
        <TableCell className="text-right font-mono text-xs">{dec(r.quantita_precedente)}</TableCell>
        <TableCell className="text-right font-mono text-xs font-semibold">{dec(r.quantita_periodo)}</TableCell>
        <TableCell className="text-right font-mono text-xs">{dec(r.quantita_cumulata)}</TableCell>
        <TableCell className={`text-right font-mono text-xs ${Number(r.quantita_residua) < 0 ? "text-rose-700" : ""}`}>{dec(r.quantita_residua)}</TableCell>
        <TableCell className="text-right font-mono text-xs">{r.prezzo === null ? "—" : eur(r.prezzo, 4)}</TableCell>
        <TableCell className="text-right font-mono text-xs">{eur(r.importo_precedente)}</TableCell>
        <TableCell className="text-right font-mono text-xs font-semibold">{eur(r.importo_periodo)}</TableCell>
        <TableCell className="text-right font-mono text-xs">{eur(r.importo_cumulato)}</TableCell>
        <TableCell><Azioni r={r} act={act} /></TableCell>
      </TableRow>
      {open && <TableRow><TableCell colSpan={12}><Quote quote={r.quote} /></TableCell></TableRow>}
    </Fragment>
  );
};

export const SalRighe = ({ righe, act }) => (
  <div className="overflow-x-auto" data-testid="sal-righe">
    <Table>
      <TableHeader><TableRow>
        <TableHead>N.</TableHead><TableHead>Lavorazione</TableHead><TableHead>UM</TableHead>
        <TableHead className="text-right">Q.tà prec.</TableHead><TableHead className="text-right">Q.tà periodo</TableHead><TableHead className="text-right">Q.tà cumulata</TableHead><TableHead className="text-right">Residua</TableHead>
        <TableHead className="text-right">Prezzo</TableHead><TableHead className="text-right">Importo prec.</TableHead><TableHead className="text-right">Importo periodo</TableHead><TableHead className="text-right">Cumulato</TableHead><TableHead />
      </TableRow></TableHeader>
      <TableBody>
        {righe.map((r) => <Riga key={r.id} r={r} act={act} />)}
        {!righe.length && <TableRow><TableCell colSpan={12} className="text-sm text-slate-500" data-testid="sal-righe-vuote">Nessuna quantità verificata da contabilizzare nel periodo.</TableCell></TableRow>}
      </TableBody>
    </Table>
  </div>
);
